/* ================================================== */
/* FASTCLICK
/* ================================================== */

$(function(){
	FastClick.attach(document.body);
});